const advertiserMode = process.env.VUE_APP_ADVERTISER_MODE || 'ezoic'

const adsense = {
  name: 'adsense',
  percentage: advertiserMode === 'adsense' ? 100 : 0,
  adClient: 'ca-pub-7786462965305382',
  adUnits: {
    'content-first': {
      adSlot: '5256470147',
      adFormat: 'auto',
    },
    'content-fourth': {
      adSlot: '3340769156',
      adFormat: 'auto',
    },
    'content-last': {
      adSlot: '7691061799',
      adFormat: 'auto',
    },
    'content-second': {
      adSlot: '3124296672',
      adFormat: 'auto',
    },
    'content-third': {
      adSlot: '2171141807',
      adFormat: 'auto',
    },
    'content-zero': {
      adSlot: '1317225132',
      adFormat: 'auto',
    },
    leaderboard: {
      adSlot: '5382480231',
      adFormat: 'auto',
    },
    rectangle: {
      adSlot: '6085187816',
      adFormat: 'auto',
    },
    'solved-rectangle': {
      adSlot: '6972308745',
      adFormat: 'auto',
    },
    'sticky-skyscraper': {
      adSlot: '7407399961',
      adFormat: 'auto',
    },
  },
}

const ezoic = {
  name: 'ezoic',
  percentage: advertiserMode === 'ezoic' ? 100 : 0,
  adUnits: {
    leaderboard: {
      adSlot: '103',
    },
    'sticky-skyscraper': {
      adSlot: '104',
    },
    rectangle: {
      adSlot: '105',
    },
    'solved-rectangle': {
      adSlot: '106',
    },
    'content-zero': {
      adSlot: '116',
    },
    'content-first': {
      adSlot: '107',
    },
    'content-last': {
      adSlot: '108',
    },
    'content-second': {
      adSlot: '109',
    },
    'content-third': {
      adSlot: '114',
    },
    'content-fourth': {
      adSlot: '115',
    },
    footer: {
      adSlot: '113',
    },
  },
}

export { adsense, ezoic }
